import { makeStyles } from "@material-ui/core/styles";

const style = makeStyles((theme) => ({
  mainContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "stretch",
  },
  marker: {
    cursor: "pointer",
    width: "50px",
    height: "80px",
    top: "-80px",
    left: "-25px",
    position: "relative",
  },
  tableContainer: {
    width: "70%",
  },
  mapContainer: {
    width: "28%",
  },
  textExpanded: {
    marginBottom: "10px",
    fontSize: "15px",
  },
  divButtons: {
    display: "flex",
    justifyContent: "center",
  },
  actionButton: {
    margin: "10px",
  },
  cardActionArea: {
    display: "flex",
  },
  dialog: {
    fontSize: 20,
  },
  cardMedia: {
    height: "auto",
    width: "auto",
    maxWidth: "250px",
    maxHeight: "250px",
    display: "flex",
  },
  cellStyle: {
    width: "20vh",
    maxWidth: "20vh",
    textAlign: "left",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    margin: "0px",
    padding: "0px",
  },
  headerStyle: {
    width: "20vh",
    maxWidth: "20vh",
    textAlign: "left",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    margin: "0px",
    padding: "0px",
  },
}));

export default style;
